<template>
  <div class="fill-over">
    <div class="img-wrap">
      <img src="../../../assets/image/success.png" alt="" />
    </div>
    <h4>提交成功</h4>
    <p>
      <span>{{ $route.query.name }}</span
      >，欢迎加入弘策科技大家庭
    </p>
  </div>
</template>
<script>
export default {
  name: 'submitOver',
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.fill-over {
  width: 100%;
  max-width: 750px;
  height: 90vh;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
  .img-wrap {
    width: 100%;
    img {
      width: 80px;
    }
  }

  h4 {
    font-size: 17px;
    font-weight: 500;
    color: #03081a;
    line-height: 16px;
    margin: 16px 0 12px 0;
  }
}
p {
  font-size: 18px;
  font-weight: 600;
  color: #1b1b1b;
  line-height: 14px;
  margin: 20px 0 50px 0;
}
</style>
